import { type FC } from 'react'
import { useTranslation } from 'react-i18next'
import { useSessionContext } from 'supertokens-auth-react/recipe/session'

import { MembershipCard } from '@/containers/MembershipCard/MembershipCard'
import { useNextBooking } from '@/containers/MyNextVisitCard/hooks/useNextBooking'
import MyNextVisitCard from '@/containers/MyNextVisitCard/MyNextVisitCard'
import PaymentMethodsCard from '@/containers/PaymentMethodsCard/PaymentMethodsCard'

export const HomePage: FC = () => {
  const { t } = useTranslation('home-page')
  const session = useSessionContext()
  const firstName = !session.loading && session?.accessTokenPayload?.firstName
  const { nextBooking, loading, error, refetch } = useNextBooking()
  const showNextVisitCard = loading || error || Boolean(nextBooking)

  return (
    <>
      {firstName && (
        <h1 className="mb-5 font-guttaperka text-[40px] font-semibold md:mb-10 md:text-5xl">
          {t('greeting', { name: firstName })}
        </h1>
      )}
      <div className="flex flex-col md:block md:columns-2 md:gap-4 xl:gap-8">
        <PaymentMethodsCard className="avoid-column-break mb-5 md:mb-8" />
        <div />

        {showNextVisitCard && (
          <MyNextVisitCard
            nextBooking={nextBooking}
            loading={loading}
            error={error}
            refetch={refetch}
            className="avoid-column-break mb-5 md:mb-8"
          />
        )}

        <MembershipCard className="avoid-column-break mb-5 md:mb-8" />
      </div>
    </>
  )
}
